export default "assets/logo-5b50b105.svg";